import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(duration);

export const formatMillisecondsToTime = (milliseconds: number): string => {
  const durationObject = dayjs.duration(milliseconds);
  const hours = Math.floor(durationObject.asHours());
  const minutes = durationObject.minutes();

  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};
